import '@backstage/cli/asset-types';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

//if request from backend doesn't work, try here, where it is served. 

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App />);
}